export default __webpack_public_path__ + "static/media/132068967_230688068424384_1667532190582190439_n.6fcf047a.jpg";